import { Controller } from "@hotwired/stimulus";

const ANIMATION_DURATION = "0.8s";
const ANIMATION_EASING = "ease";
const STAGGER_FEW = 0.25;
const STAGGER_MANY = 0.1;
const STAGGER_THRESHOLD = 3;
const INTERSECTION_THRESHOLD = 0.15;

export default class extends Controller {
  static targets = ["item"];

  connect() {
    const stagger =
      this.itemTargets.length <= STAGGER_THRESHOLD ? STAGGER_FEW : STAGGER_MANY;

    this.itemTargets.forEach((el, i) => {
      el.style.opacity = "0";
      el.style.transform = "translateY(20px)";
      el.dataset.animationIndex = i;
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const el = entry.target;
          const delay = el.dataset.animationIndex * stagger;

          el.style.transition = `opacity ${ANIMATION_DURATION} ${ANIMATION_EASING} ${delay}s, transform ${ANIMATION_DURATION} ${ANIMATION_EASING} ${delay}s`;
          el.style.opacity = "1";
          el.style.transform = "translateY(0)";

          this.observer.unobserve(el);
        });
      },
      { threshold: INTERSECTION_THRESHOLD },
    );

    this.itemTargets.forEach((el) => this.observer.observe(el));
  }

  disconnect() {
    this.observer?.disconnect();
  }
}
